"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logo = void 0;
var _sn_dev = _interopRequireDefault(require("../assets/img/sn_dev.png"));
var _sn_qa = _interopRequireDefault(require("../assets/img/sn_qa.png"));
var _sn_uat = _interopRequireDefault(require("../assets/img/sn_uat.png"));
var _sn_prod = _interopRequireDefault(require("../assets/img/sn_prod.png"));
var _cs_dev = _interopRequireDefault(require("../assets/img/cs_dev.png"));
var _cs_qa = _interopRequireDefault(require("../assets/img/cs_qa.png"));
var _cs_uat = _interopRequireDefault(require("../assets/img/cs_uat.png"));
var _cs_preuat = _interopRequireDefault(require("../assets/img/cs_preuat.png"));
var _cs_sap = _interopRequireDefault(require("../assets/img/cs_sap.png"));
var _cs_hotfix = _interopRequireDefault(require("../assets/img/cs_hotfix.png"));
var _cornerstoneLogo = _interopRequireDefault(require("../assets/img/cornerstone-logo.png"));
var _cs_uat2 = _interopRequireDefault(require("../assets/img/cs_uat2.png"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const hostname = window && window.location && window.location.hostname;
const env = [{
  key: "local",
  value: "localhost",
  logo: _cornerstoneLogo.default
}, {
  key: "prod",
  value: "cornerstone.elcompanies",
  logo: _cornerstoneLogo.default
}, {
  key: "dev",
  value: "cornerstone-dev",
  logo: _cs_dev.default
}, {
  key: "qa",
  value: "cornerstone-qa",
  logo: _cs_qa.default
}, {
  key: "preuat",
  value: "cornerstone-preuat",
  logo: _cs_preuat.default
}, {
  key: "uat2",
  value: "cornerstone-uat2",
  logo: _cs_uat2.default
}, {
  key: "uat",
  value: "cornerstone-uat",
  logo: _cs_uat.default
}, {
  key: "sap",
  value: "cornerstone-sap",
  logo: _cs_sap.default
}, {
  key: "hotfix",
  value: "cornerstone-hotfix",
  logo: _cs_hotfix.default
}, {
  key: "dev-sn",
  value: "suppliernet-dev",
  logo: _sn_dev.default
}, {
  key: "qa-sn",
  value: "suppliernet-qa",
  logo: _sn_qa.default
}, {
  key: "uat-sn",
  value: "suppliernet-uat",
  logo: _sn_uat.default
}, {
  key: "prod-sn",
  value: "suppliernet.elcompanies",
  logo: _sn_prod.default
}];
const logo = exports.logo = (env.find(category => hostname.includes(category.value)) || env[0]).logo;